export const AUTH_TOKEN =  document.querySelector('meta[name=csrf-token]') && document.querySelector('meta[name=csrf-token]').attributes.content.value;